import { ConfirmInfoVerification } from "../components/confirmInfo/ConfirmInfoVerification";

export function ConfirmInfoPage() {
  return <ConfirmInfoVerification />;
}
